import type { Call_To_Action } from "~/core";

export const isCallToActionBlock = (item: unknown): item is Call_To_Action => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "call_to_action"
  );
};
